<template>
    <div class="zq-popup zq-popup--with-steps zq-popup--bigger zq-popup--visible">
        <div class="zq-popup__container">
            <div class="zq-popup__title">
                <translate v-if="popupPayload.action==='create'" :key="'add-new-team'">Add new Team</translate>
                <translate v-if="popupPayload.action==='edit'" :key="'edit-team'">Edit team</translate>
                <div @click="closeTeamPopup()" class="zq-popup__close-button"></div>
            </div>
            <div class="steps__container">
                <div class="steps__step" v-bind:class="{
                     'steps__step--current' : stepLocation == 'step-1',
                     'steps__step--done' : stepLocation == 'step-2' || stepLocation == 'step-3'}">
                    <strong v-translate>Name</strong>
                </div>
                <div class="steps__step" v-bind:class="{
                     'steps__step--current' : stepLocation == 'step-2',
                     'steps__step--done' : stepLocation == 'step-3'}">
                    <strong v-translate>Leader</strong>
                </div>
                <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-3'}">
                    <strong v-translate>Members</strong>
                </div>
            </div>
            <div class="zq-popup__content custom-scroller">
                <div class="zq-tabs__container" v-if="stepLocation === 'step-1'">
                    <h2 :key="'set-team-name'" v-translate>Set your team name</h2>
                    <input-field label="Team name" type="text" :field="$v.team.name"/>
                </div>

                <div class="zq-tabs__container" v-if="stepLocation === 'step-2'">
                    <h2 class="m-b" :key="'choose-team-leader'" v-translate>Choose your team leader</h2>
                    <p class="m-b" :key="'choose-team-leader-explain'" v-translate>Choose from your existing members or add new person as team leader.</p>
                    <div class="table__search">
                        <input v-model="filterLeader" type="text" class="input--text"
                               :placeholder="search_team_members_placeholder"/>
                    </div>
                    <div>
                        <div class="my-people__choose-member">
                            <div v-for="person in filtered_leaders" class="my-people__member"
                                 :key="person.id"
                                 v-bind:class="{'my-people__member--selected': team.leader == person.id, 'my-people__member--no-image': !person.profile_photo}">
                                <div v-if="person.profile_photo" class="my-people__member-image">
                                    <img :src="person.profile_photo">
                                </div>
                                <div class="my-people__member-details">
                                    <div class="my-people__member-name">{{person.first_name}} {{person.last_name}}</div>
                                    <div class="my-people__member-role">{{person.relation_display}}</div>
                                    <div class="my-people__member-gender">{{person.gender_display}}</div>
                                    <div class="my-people__member-birthday">{{person.birth_date|moment('LL')}} <span
                                            v-if="person.birth_time">@ {{person.birth_time_display}}</span>
                                    </div>
                                    <div class="my-people__member-actions">
                                        <button @click="team.leader = person.id" v-if="team.leader != person.id" class="button button--small button--gray" :key="'set-as-team-leader'" v-translate>Set as team leader</button>
                                        <div v-if="team.leader == person.id" class="message message--with-icon message--success" :key="'current-team-leader'" v-translate>Team leader</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="zq-tabs__container" v-if="stepLocation === 'step-3'">
                    <h2 class="m-b" :key="'choose-team-members'" v-translate>Choose team members</h2>
                    <p class="m-b" :key="'choose-team-members-explain'" v-translate>Choose from your existing members.</p>
                    <div class="table__search">
                        <input v-model="filter" type="text" class="input--text"
                               :placeholder="search_team_members_placeholder"/>
                    </div>
                    <div>
                        <div class="my-people__choose-member">
                            <div v-for="person in filtered_people" class="my-people__member"
                                 :key="person.id"
                                 v-bind:class="{'my-people__member--selected': team.members.includes(person.id), 'my-people__member--no-image': !person.profile_photo}">
                                <div v-if="person.profile_photo" class="my-people__member-image">
                                    <img :src="person.profile_photo">
                                </div>
                                <div class="my-people__member-details">
                                    <div class="my-people__member-name">{{person.first_name}} {{person.last_name}}</div>
                                    <div class="my-people__member-role">{{person.relation_display}}</div>
                                    <div class="my-people__member-gender">{{person.gender_display}}</div>
                                    <div class="my-people__member-birthday">{{person.birth_date|moment('LL')}} <span
                                            v-if="person.birth_time">@ {{person.birth_time_display}}</span>
                                    </div>
                                    <div class="my-people__member-actions">
                                        <button @click="choosePerson(person)" v-if="!team.members.includes(person.id)" class="button button--small button--gray" :key="'add-member-to-the-team'" v-translate>Add member to the team</button>
                                        <div v-if="team.members.includes(person.id)" class="message message--with-icon message--success" :key="'added-to-the-team'" v-translate>Added to the team</div>
                                        <button @click="removePerson(person.id)" v-if="team.members.includes(person.id)" class="button button--small button--gray button--red-on-hover" :key="'remove-member-from-the-team'" v-translate>Remove member from the team</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="zq-popup__bottom">
                <button @click="closeTeamPopup()" class="button button--gray" v-translate>Close</button>

                <button v-if="stepLocation === 'step-1'" @click="saveName()" class="button button--primary" :key="'next'" v-translate>Next</button>

                <button v-if="stepLocation === 'step-2'" @click="stepLocation = 'step-1'" class="button button--gray" :key="'back'" v-translate>Back</button>
                <button v-if="stepLocation === 'step-2'" @click="saveLeader()" class="button button--primary" :key="'next'" v-translate>Next</button>

                <button v-if="stepLocation === 'step-3'" @click="stepLocation = 'step-2'" class="button button--gray" :key="'back'" v-translate>Back</button>
                <button v-if="stepLocation === 'step-3'" @click="saveTeam()" class="button button--primary" :key="'create-team'" v-translate>Save team</button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex';
    import {EventBus} from '../../event-bus';
    import axios from 'axios';
    import {required} from 'vuelidate/lib/validators';
    import InputField from "./InputField";

    export default {
        name: 'AddNewTeam',
        data() {
            return {
                team: {
                    name: "",
                    organization: "",
                    leader: "",
                    members: [],
                },
                organization: {},
                stepLocation: 'step-1',
                tab_location: 'choose-people',
                people: [],
                success_profile: {},
                allowance: 0,
                filter: '',
                filterLeader: '',
                search_team_members_placeholder: this.$gettext('Search members'),
            }
        },
        components: {InputField},
        computed: {
            ...mapState([
                'popupPayload'
            ]),
            filtered_people: function() {
                if(this.filter){
                    return this.people.filter(person => person.id !== this.team.leader && (person.first_name.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0 || person.last_name.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0))
                }
                return this.people.filter(person => person.id !== this.team.leader)
            },
            filtered_leaders: function() {
                if(this.filterLeader){
                    return this.people.filter(person => person.first_name.toLowerCase().indexOf(this.filterLeader.toLowerCase()) >= 0 || person.last_name.toLowerCase().indexOf(this.filterLeader.toLowerCase()) >= 0)
                }
                return this.people
            },
        },
        methods: {
            ...mapActions([
                'closePopup'
            ]),
            choosePerson: function(person) {
                if (this.team.members.length < 7){
                    this.team.members.push(person.id)
                }
            },
            removePerson: function(person) {
                var index = this.team.members.indexOf(person);
                if (index > -1) {
                    this.team.members.splice(index, 1);
                }
            },
            saveName: function() {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.stepLocation = 'step-2'
                }
            },
            saveLeader: function() {
                if (this.team.leader!='') {
                    this.removePerson(this.team.leader)
                    this.stepLocation = 'step-3'
                }
            },
            saveTeam: async function () {
                if(this.team.members.length!==0){
                    if (this.popupPayload['action'] === 'create') {
                        (await axios.post('/api/navigator/teams/', this.team))
                    }
                    if (this.popupPayload['action'] === 'edit') {
                        (await axios.put('/api/navigator/teams/' + this.team.id + '/', this.team))
                    }
                    EventBus.$emit('reload-organization')
                    this.closePopup()
                }
            },
            closeTeamPopup: function() {
                this.closePopup()
            },
        },
        validations: {
            team: {
                name: {required}
            }
        },
        beforeMount: async function () {
            this.loading = true;
            this.organization = this.popupPayload['organization']
            this.removePerson(this.team.leader)
            if (this.popupPayload['action'] === 'create') {
                this.team.organization = this.popupPayload['organization'].id
            }
            if (this.popupPayload['action'] === 'edit') {
                this.team = this.popupPayload['team']
            }
            this.people = (await axios.get('/api/navigator/people/')).data
            // this.success_profile = (await axios.get('/api/navigator/success-profile/')).data
            // this.avatar = (await axios.get('/api/my-profile/profile-photo/')).data.profile_photo
            this.loading = false;
        }
    }
</script>
